import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DateFromTo } from '../../../models/common';
import { QcsDateTimePicker } from '../basic/QcsDateTimePicker';
import { FormContainer } from '../form/FormContainer';

interface Props {
  value?: DateFromTo;
  onChange: (value?: DateFromTo) => void;
}

export const GridFilterDateTimeFromTo: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const handleChangeFrom = (date?: Date | null) => {
    onChange({ from: date ? date : undefined, to: value?.to });
  };

  const handleChangeTo = (date?: Date | null) => {
    let finalDate = date;

    // Only set default time to 23:55 when initially selecting a date (when value.to is not set)
    // and the selected time is midnight (00:00:00)
    if (date && !value?.to && date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
      finalDate = new Date(date);
      finalDate.setHours(23);
      finalDate.setMinutes(55);
      finalDate.setSeconds(0);
    }

    onChange({ from: value?.from, to: finalDate ? finalDate : undefined });
  };

  return (
    <FormContainer>
      <QcsDateTimePicker
        label={t('common.from')}
        value={value?.from ? value.from : null}
        onChange={handleChangeFrom}
      />
      <QcsDateTimePicker
        label={t('common.to')}
        value={value?.to ? value.to : null}
        onChange={handleChangeTo}
      />
    </FormContainer>
  );
};
